// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background: #3A3A3A;
  margin: 0;
}

body.ouro-v2-route {
  background: #050507;
}

html.ouro-scroll-lock {
  overscroll-behavior: none;
  scrollbar-width: none;
}

html.ouro-scroll-lock::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

* {
  scrollbar-width: thin;
  scrollbar-color: #e8a33d rgba(5, 5, 7, 0.45);
}

*::-webkit-scrollbar {
  width: 3px;
}

*::-webkit-scrollbar-button {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

*::-webkit-scrollbar-track {
  background: rgba(5, 5, 7, 0.45);
}

*::-webkit-scrollbar-thumb {
  background: #e8a33d;
  border-radius: 3px;
}

*::-webkit-scrollbar-thumb:hover {
  background: rgba(232, 163, 61, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/components/app/App.scss"],"names":[],"mappings":"AAGA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Lato\");\n\n\nbody {\n  background: #3A3A3A;\n  margin: 0;\n}\n\nbody.ouro-v2-route {\n  background: #050507;\n}\n\nhtml.ouro-scroll-lock {\n  overscroll-behavior: none;\n  scrollbar-width: none;\n}\n\nhtml.ouro-scroll-lock::-webkit-scrollbar {\n  display: none !important;\n  width: 0 !important;\n  height: 0 !important;\n}\n\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #e8a33d rgba(5, 5, 7, 0.45);\n}\n\n*::-webkit-scrollbar {\n  width: 3px;\n}\n\n*::-webkit-scrollbar-button {\n  display: none !important;\n  width: 0 !important;\n  height: 0 !important;\n}\n\n*::-webkit-scrollbar-track {\n  background: rgba(5, 5, 7, 0.45);\n}\n\n*::-webkit-scrollbar-thumb {\n  background: #e8a33d;\n  border-radius: 3px;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background: rgba(232, 163, 61, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
